import "./share.css";
import { PermMedia, Label, Room, EmojiEmotions } from "@mui/icons-material"
import CollectionsIcon from '@mui/icons-material/Collections';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';

import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';

import InsertEmoticonOutlinedIcon from '@mui/icons-material/InsertEmoticonOutlined';
import { useContext, useRef, useState } from "react";
import axiosInstance from '../../config';
import { Link, useNavigate } from "react-router-dom";
import SocialContext from "../../context/SocialContext";

const host = "http://localhost:5000/api/"

export default function Share() {
  const navigate = useNavigate();
  const { user, fetchcurrentuserfun } = useContext(SocialContext);
  // const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const PF = "https://socialshub.netlify.app/images/";

  // for sharePost
  const desc = useRef();
  const [file, setfile] = useState(null);

  const submitfun = async (event) => {
    event.preventDefault();
    const newPost = {
      userId: user._id,
      desc: desc.current.value,
    }
    console.log("--->", newPost);
    try {
      if (desc.current.value === "") {
        window.alert("Write something and try again!");
      } else {
        const response = await axiosInstance.post(`/api/posts/newpost`, newPost);
        navigate('/');
      }
    } catch (error) {
      console.log("share ke error me hai ", error);
    }
  }

  return (
    <div className="share">
      <div className="shareWrapper">
        <div className="shareTop">
          <Link style={{ 'textDecoration': 'none' }} to={`/profile/${user._id}`}>
            <img className="shareProfileImg" src={user.profilePic ? user.profilePic : PF + "/person/noprofile.png"} alt="" />
          </Link>
          <input
            placeholder={`What's in your mind ${user.username}?`}
            className="shareInput"
            ref={desc}
            onClick={() => { navigate('/share') }}
          />
        </div>
        <hr className="shareHr" />
        <div className="shareBottom">
          <div className="shareIcons firstIcon">
            <Link style={{ 'textDecoration': 'none' }} className="temp" to={'/share'}>
              <EmojiEventsIcon style={{ 'color': 'red', 'marginRight': '5px' }} />
              <span>Achievement</span>
            </Link>
          </div>
          <div className="shareIcons">
            <Link style={{ 'textDecoration': 'none' }} className="temp" to={'/share'}>
              <CollectionsIcon style={{ 'color': 'green', 'marginRight': '5px' }} />
              <span>Photos</span>
            </Link>
          </div>
          <div className="shareIcons">
            <Link style={{ 'textDecoration': 'none' }} className="temp" to={'/share'}>
              <InsertEmoticonOutlinedIcon style={{ 'color': 'yellow', 'marginRight': '5px' }} />
              <span>Fellings</span>
            </Link>
          </div>
        </div>
      </div>
    </div >
  );
}